import config from '../../config'
import _ from 'lodash'
import Promise from 'bluebird'
import axios from 'axios'
import customEngines from '../../modules/custom-engines'

const TABLE_NAME = 'nlu-external-models'

export default {
  namespaced: true,

  state: {
    customModels: [],
    customEngines: []
  },

  actions: {
    initCustomModel ({ commit, dispatch }, { id }) {
      commit('knowledgebase/SET_MODEL_ID', id, { root: true })
      dispatch('knowledgebase/notifications/clearNotifications', null, { root: true })
    },

    async fetchCustomEngines ({ commit }) {
      commit('SET_CUSTOM_ENGINES', customEngines)
    },

    async fetchCustomModels ({ rootState, commit }) {
      try {
        const { data: customModels } = await axios.get(`${config.SDK_API_URL}/storage/${TABLE_NAME}`, {
          headers: {
            Authorization: `USER ${rootState.auth.token}`
          },
          json: true
        })
        const customModelsIds = _.map(customModels.value.records, 'key')
        const getEndpoint = (modelId) => `${config.SDK_API_URL}/storage/${TABLE_NAME}/${modelId}`
        const customModelsData = await Promise.map(customModelsIds, (modelId) => axios.get(getEndpoint(modelId), {
          headers: {
            Authorization: `USER ${rootState.auth.token}`
          },
          json: true
        }))
        const mappedModelsData = _.map(customModelsData, item => _.get(item, 'data.value'))
        commit('SET_CUSTOM_MODELS', mappedModelsData)
      } catch (error) {
        console.log('Failed to fetch custom models: ', error)
      }
    },

    async updateCustomModel ({ rootState, commit, dispatch }, payload) {
      try {
        const value = _.chain(payload)
          .pick(['id', 'name', 'description', 'img', 'engine', 'settings'])
          .set('modifiedDate', _.floor(Date.now() / 1000))
          .set('modifiedBy', rootState.auth.userId)
          .value()

        const { data } = await axios.post(`${config.SDK_API_URL}/storage/${TABLE_NAME}/${value.id}`, {
          value
        }, {
          headers: { Authorization: `USER ${rootState.auth.token}` }
        })

        if (data.value) {
          commit('UPDATE_CUSTOM_MODEL', data.value)
        } else {
          await dispatch('fetchCustomModels')
        }

        return data
      } catch (error) {
        dispatch('knowledgebase/notifications/addError',
          { titleLabel: 'store.customModel.updateCustomModel.errorNotification.title', error },
          { root: true }
        )
      }
    },

    async createCustomModel ({ rootState, dispatch }, payload) {
      try {
        const value = _.chain(payload)
          .pick(['id', 'name', 'description', 'img', 'engine', 'settings'])
          .set('modifiedDate', _.floor(Date.now() / 1000))
          .set('modifiedBy', rootState.auth.userId)
          .value()

        const { data } = await axios.post(`${config.SDK_API_URL}/storage/${TABLE_NAME}/${value.id}`, {
          value
        }, {
          headers: {
            Authorization: `USER ${rootState.auth.token}`
          }
        })
        await dispatch('fetchCustomModels')

        return data
      } catch (error) {
        dispatch('knowledgebase/notifications/addError',
          { titleLabel: 'store.customModel.createCustomModel.errorNotification.title', error },
          { root: true }
        )
      }
    },

    async deleteCustomModel ({ rootState, dispatch, commit }, modelId) {
      try {
        const endpoint = `${config.SDK_API_URL}/storage/${TABLE_NAME}/${modelId}`
        const { data } = await axios.delete(endpoint, {
          headers: {
            Authorization: `USER ${rootState.auth.token}`
          }
        })
        commit('DELETE_CUSTOM_MODEL', { id: modelId })

        return data
      } catch (error) {
        dispatch('knowledgebase/notifications/addError',
          { titleLabel: 'store.customModel.deleteCustomModel.errorNotification.title', error },
          { root: true }
        )
      }
    }
  },

  mutations: {
    DELETE_CUSTOM_MODEL (state, { id }) {
      state.customModels = state.customModels.filter(model => model.id !== id)
    },

    SET_CUSTOM_MODELS (state, data) {
      state.customModels = data
    },

    UPDATE_CUSTOM_MODEL (state, updatedModel) {
      state.customModels = state.customModels.map((customModel) => {
        if (customModel.id !== updatedModel.id) {
          return customModel
        }

        return _.merge(customModel, updatedModel)
      })
    },

    SET_CUSTOM_ENGINES (state, data) {
      state.customEngines = data
    }
  }
}
